import { createSlice } from '@reduxjs/toolkit';

interface MaterialState {
  tableList: Array<any>;
  isLoaded: boolean;
  savedList: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
}

const initialState: MaterialState = {
  tableList: [],
  isLoaded: false,
  savedList: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
};

const materialSlice = createSlice({
  name: 'material',
  initialState,
  reducers: {
    reloadMaterial(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationMaterial(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListMaterial(state, action) {
      state.savedList = action.payload;
    },
  },
});

const { actions, reducer: materialReducer } = materialSlice;

export const {
  reloadMaterial,
  updateSavedPaginationMaterial,
  updateSavedListMaterial,
} = actions;

export default materialReducer;
